// Documentation in docs/?modparams[id]=355&output=view

var map;
var markers = {};
var listOfMarkers = new Array();
var numberOfMarkers;
var markersInCluster = {};
var numberMarkersInCluster;
var zoomBounds = new Array();
var zoomToItem = new Array();
var osmStandardLayer;
var indexOfHighlightedMarker = -1;
var originalContentHighlightedMarker = '';
var bLoadedAndDisplayedMap = false;

// Extending MarkerCluster to add some padding for showing the headlines.
// It works fine for big viewports but when the display is small there is a chance that the cluster won't expand
// when clicked or touched because there is not enough space to add the padding
var windowWidth = $(window).width();
var windowHeight = $(window).height();
if (windowWidth > 672 && windowHeight > 480) {
	L.MarkerCluster = L.MarkerCluster.extend({
		//Zoom to the extents of this cluster but adding padding to fit the popup (headline) inside the viewport
		zoomToBounds: function () {
			this._group._map.fitBounds(this._bounds,{paddingTopLeft: [30,50], paddingBottomRight: [30,10]});
		}
	});
}

var smallIcon = new SmallIcon();

// When an item loaded after scrolling the page (item does not appear in the current map) must be shown on the map, a
// new page will be loaded but first we make sure to turn on the map setting.
$(document).on('click','.jscroll-added .img-linkToMap', function(e) {
	// if map is not active (icon's opacity is currently set to 1.0), then activate it.
	if (!$('#icon_worldmap').hasClass('mapOpen')) {
		$('#icon_worldmap').click();
	}
});


function toggleMap(deviceID) {

	var xmlhttp = new XMLHttpRequest();

	// if map is active (icon's opacity is currently set to 0.5)
	if ($('#icon_worldmap').hasClass('mapOpen')) {
	
		$('#map').slideToggle(function() {
			$('#icon_worldmap').removeClass('mapOpen');
			document.getElementById('icon_worldmap').title = 'Kaart aan';
			
			// save this setting for the current device
			xmlhttp.open('GET','/ajax/mapajax?deviceid='+deviceID+'&hide=1', true);
			xmlhttp.send();
		
		});

	} else {
	
		// if the map was not yet loaded, load and display it
		if (!bLoadedAndDisplayedMap) {
			loadAndDisplayMap();
		} else {
			$('#map').slideToggle();
			$('#icon_worldmap').addClass('mapOpen');
			document.getElementById('icon_worldmap').title = 'Kaart uit';
		}
		
		// save this setting for the current device
		xmlhttp.open('GET','/ajax/mapajax?deviceid='+deviceID+'&hide=0', true);
		xmlhttp.send();
	}

}


$(document).ready(function() {
	if (typeof mapMustBeShown != 'undefined' && mapMustBeShown) {
		loadAndDisplayMap();
	}
});


function loadAndDisplayMap() {

	var mapDiv = $('#map');
	$(mapDiv).css('display', 'block');

	// map height < small viewport height
	forceMapHeightFitSmallViewPort(mapDiv);
	$(window).resize(function() {
			forceMapHeightFitSmallViewPort(mapDiv);
	});

	initWizard();

	var iTotalElements = $("#dbv5-no tbody tr").not('.dbv5-html-footer').length;

	var fTempLat = 200.0;
	var fTempLon = 200.0;
	var bAllSameCoords = false;

	$("#dbv5-no tbody tr").not('.dbv5-html-footer').each(function(index) {

		// get all data attributes from this tr at once
		var info = $(this).data();

		// the data-attributes were not set
		if (typeof info['article.article_id'] == 'undefined') {
			return 'continue';
		}

		var id    = info['article.article_id'];
		var title = info['article.cache_header'];
		var lat   = info['location.lat'];
		var lon   = info['location.lon'];

		// skip if important data is missing
		if (id == '' || title == '' || lat == '' || lon == '') {
			return 'continue';
		}

		var fLat = parseFloat(lat);
		var fLon = parseFloat(lon);
		
		var hash = '#item' + id;
		

		if (fLat == fTempLat && fLon == fTempLon) {
			bAllSameCoords = true;
		} else {
			bAllSameCoords = false;
		}

		fTempLat = fLat;
		fTempLon = fLon;

		if ( info['location.bbleft']!='' && info['location.bbtop']!='' &&
		     info['location.bbright']!='' && info['location.bbbottom']!='' ) {

			var fBoxLeft = parseFloat(info['location.bbleft']);     //w
			var fBoxTop = parseFloat(info['location.bbtop']);       //n
			var fBoxRight = parseFloat(info['location.bbright']);   //e
			var fBoxBottom = parseFloat(info['location.bbbottom']); //s

			if ( iTotalElements == 1 || (index === iTotalElements && bAllSameCoords) ) {
				zoomBounds.push([fBoxBottom, fBoxLeft]);
				zoomBounds.push([fBoxTop, fBoxRight]);
			}

			zoomToItem[id] = [[fBoxBottom, fBoxLeft],[fBoxTop, fBoxRight]];

		} else {

			zoomToItem[id] = [fLat, fLon];

		}
		
		title = wrapTitle(title);

		///DOM element for popup
		var domElem = document.createElement('a');
		domElem.href = hash;
		domElem.innerHTML = title;

		// marker
		var marker = L.marker([fLat,fLon], {icon: smallIcon, markerID: id});
		marker.bindPopup(domElem,
		                {
		                    maxWidth: 500,
		                    autoPan: false,
		                    autoClose: false,
		                    closeButton: false,
		                    closeOnClick: false
		                }
		);
		listOfMarkers.push(marker);

		// make sure the lat and lon of the marker are included
		zoomBounds.push([fLat, fLon]);

	});
	
	numberOfMarkers = listOfMarkers.length;

	// add markers to cluster group
	markers.addLayers(listOfMarkers);

	// add cluster group to map
	map.addLayer(markers);

	if (zoomBounds.length !== 0 && (iTotalElements == 1 || bAllSameCoords || iTotalElements > 20)) {
		map.fitBounds(zoomBounds);
	} else if (zoomBounds.length !== 0) {
		//Adding padding to fit the popup (headline) inside the viewport
		map.fitBounds(zoomBounds,{paddingTopLeft: [30,50], paddingBottomRight: [30,10]});
	} else {
		zoomBounds.push([70, -100]);
		zoomBounds.push([0, 100]);
		map.fitBounds(zoomBounds);
	}

	bLoadedAndDisplayedMap = true;
	
	$('#icon_worldmap').addClass('mapOpen');

	// all headlines must be visible
	// queue the code to run once the current call stack is finished executing -> wait for the font to load, otherwise
	// the popup size is not accurate
	setTimeout(function() {
		openAllPopups();
	},0);

}


function initWizard() {

	var attributionText = "<a href='/copyright?map'>&#169;</a>";
	
	osmStandardLayer = L.tileLayer('https://osm-{s}.ii.nl/osm_tiles/{z}/{x}/{y}.png',
	                       {
	                            minZoom: 1,
	                            maxZoom: 18,
	                            attribution: attributionText
	                        });

	map = L.map('map', {
	            maxBounds:[[-70, -260],[88, 260]],
	            minZoom: 1,
	            maxZoom: 18,
	            scrollWheelZoom: false,
	            layers: [osmStandardLayer]
	});


	map.attributionControl.setPrefix('');

	markers = L.markerClusterGroup({
	                                spiderfyDistanceMultiplier:4,
	                                maxClusterRadius:50,
	                                removeOutsideVisibleBounds:false
	                               });

	// Make sure the popups are always visible
	map.on('moveend', openAllPopups); //fired when the view of the map stops changing e.g. user stopped dragging the map
	markers.on('spiderfied', openAllPopups); //fired when a cluster is clicked and its markers have the same coordinates

	var ControlCloseButton = L.Control.extend({
	    options: {
	        position: 'topright'
	    },
	    onAdd: function (map) {

	        var container = L.DomUtil.create('div', 'leaflet-bar');

	        container.innerHTML = "<a class='control-close-button' href='#' title='Hide map'>&times;</a>";

	        L.DomEvent.on(container, 'click', function (e) {
	                      $('#icon_worldmap').click();
	                      e.stopPropagation();                      
	        });

	        return container;
	    }
	});

	map.addControl(new ControlCloseButton());

	// add terminator
	var t = L.terminator({fillOpacity: 0.08});
	t.addTo(map);

	// update terminator every 5 seconds
	setInterval(function(){updateTerminator(t)}, 5000);
	
	function updateTerminator(t) {
		var t2 = L.terminator();
		t.setLatLngs(t2.getLatLngs());
		t.redraw();
	}

	// For mobile:
	// enables/disables interaction with map when user taps on the map. This avoids interference with page scrolling
	// L.Browser.touch: true for all browsers on touch devices
	// L.Browser.mobile: true for modern mobile browsers
	if (L.Browser.mobile) {
		map.dragging.disable();
		map.touchZoom.disable();
		if (map.tap) {
			map.tap.disable();
		}

		$('.leaflet-control-zoom').toggle();

		// event listener function
		map.on('click', onTapEnableInteraction); 
	}


}

// Determine if all markers from a group share the same location.
// This is important to handle clusters in the maximum zoom level.
function areCoordinatesEqualInAllMarkers(arr) {
	var i;
	var lenOriginal=arr.length;
	var uniqueLats=[];
	var objLats={};
	var objLngs={};
	var uniqueLngs=[];

	for (i=0;i<lenOriginal;i++) {
		objLats[arr[i]._latlng.lat]=0;
		objLngs[arr[i]._latlng.lng]=0;
	}

	for (i in objLats) {
		uniqueLats.push(i);
		if (uniqueLats.length > 1) {
			return false;
		}
	}

	for (i in objLngs) {
		uniqueLngs.push(i);
		if (uniqueLngs.length > 1) {
			return false;
		}
	}

	return true;
}

// Zoom the map on a specific item
function showItem(itemID) {

	// if map is not active (icon's opacity is currently set to 1.0), then activate it.
	if (!$('#icon_worldmap').hasClass('mapOpen')) {
		$('#icon_worldmap').click();
	}

	// when the map was not loaded previously there must be a delay until the map is initialized
	waitForMapToShowItem(itemID);

}


// Check that map is loaded before proceeding to show a specific item
function waitForMapToShowItem(itemToFocusOn) {

	if ( bLoadedAndDisplayedMap === true ) {
		
		// determine which marker must be shown
		var markID;
		var markerToShow = -1;
		for ( var eachMarker in listOfMarkers ) {
			markID = listOfMarkers[eachMarker].options.markerID;
			if ( markID == itemToFocusOn ) {
				markerToShow = eachMarker;
				break;
			}
		}

		// reset previous highlighted marker to default style and content
		if ( indexOfHighlightedMarker !== -1 && indexOfHighlightedMarker != markerToShow &&
		     originalContentHighlightedMarker != '' ) {
			listOfMarkers[indexOfHighlightedMarker].closePopup();
			listOfMarkers[indexOfHighlightedMarker].unbindPopup();
			listOfMarkers[indexOfHighlightedMarker].bindPopup(originalContentHighlightedMarker , {
			                                                 maxWidth: 500,
			                                                 autoPan: false,
			                                                 autoClose: false,
			                                                 closeButton: false,
			                                                 closeOnClick: false
			                                                });
			listOfMarkers[indexOfHighlightedMarker].openPopup();
		}

		// Modify the marker
		if ( markerToShow != -1 ) {

			// Only modify/highlight a marker when necessary
			if ( indexOfHighlightedMarker != markerToShow ) {

				// to keep track of currently highlighted marker: original content and id
				originalContentHighlightedMarker = listOfMarkers[markerToShow].getPopup().getContent();

				indexOfHighlightedMarker = markerToShow;
				
				// new content for marker
				// adding an extra div to content. div class will add a background colour
				var domElem = document.createElement('a');
				domElem.href = '#item' + itemToFocusOn;
				domElem.innerHTML = '<div class="popup-highlighted-content">' + 
				                    originalContentHighlightedMarker.innerHTML + 
				                    '</div>';
				
				// Setting new popup content with different style
				listOfMarkers[markerToShow].closePopup();
				listOfMarkers[markerToShow].unbindPopup();
				listOfMarkers[markerToShow].bindPopup(domElem , {
				                                                 maxWidth: 500,
				                                                 autoPan: false,
				                                                 autoClose: false,
				                                                 closeButton: false,
				                                                 closeOnClick: false,
				                                                 className: 'popup-highlighted'
				                                                });
			}

			// set new view to focus on the item
			map.fitBounds(zoomToItem[itemToFocusOn]);
			
			// when popup is not open because the marker is clustered, then zoom in to show the marker (if the
			// cluster is still present in the maximum zoom level, then spiderfy and open the relevant popup)

			// we need a delay to allow ending of change in map state after panTo or fitBounds.
			setTimeout(function() {

				if ( !listOfMarkers[markerToShow].getPopup()._isOpen) {
					markers.zoomToShowLayer(listOfMarkers[markerToShow], function () {
						listOfMarkers[markerToShow].openPopup();
					});
				}

			},500);
		} else {
			// sometimes there are items without a map location, reset index of highlighted marker and
			// reset map bounds
			indexOfHighlightedMarker = -1;
			map.fitBounds(zoomBounds);
		}

	} else {

		setTimeout(function() {
			waitForMapToShowItem(itemToFocusOn);
		},300);

	}
}

// Forcing the height of the map to always fit when viewport is too small (when media queries are not enough)
// There must be space for the user to start scrolling the page. 180pxs are enough.
// Current map height for displays of max-width:42em is 200px (media query)
// Current max height for the map for greater viewports is 384px
function forceMapHeightFitSmallViewPort(div) {

	var minimumMapFreeSpace = 180;
	var mapHeight = div.height();
	var headerContainerHeight = $('.header_container').outerHeight(true);
	var windowHeight = $( window ).height();

	var maxHeight = windowHeight - minimumMapFreeSpace;

	// reduce height when required
	if ( mapHeight > maxHeight && maxHeight < 200 ) {
		div.css('height', maxHeight);
	// increase height when required
	} else if ( mapHeight < 200 && maxHeight < 200 ) {
		div.css('height', maxHeight);
	// allow the media queries to set the height again
	} else if ( maxHeight > 200 ) {
		div.css('height', '');
	}

}

// -----IDD-MINIFY-SETTINGS
// ecmaVersion:11
// -----IDD-MINIFY-SETTINGS-DONE
